import AttachmentList from "@/components/dropzone/AttachmentList";
import Swal from "sweetalert2";
export default {
  components: {
    AttachmentList: AttachmentList
  },
   data () {
      return {
        filesDataArray: '',
        fileTotalMax: 0,
        fileTotalMax2: 0,
        fileTotalMax3: 0,
        fileTotalMax4: 0,
        fileTotalMaxPN: 0,
        //fileAttacthed: []
        selectedFiles: [],
        selectedFiles2: [],
        selectedFiles3: [],
        selectedFiles4: [],
        selectedFilesPN: [],
      }
   },
   created: function () {
      console.log('Printing from the Mixin')
   },
   methods: {
      displayMessage: function () {
         console.log('Now printing from a mixin function')
      },

      removeSelectedFile(fileName) {
        const index = this.selectedFiles.indexOf(fileName);
        if (index !== -1) {
          this.selectedFiles.splice(index, 1);
        }
      },
      removeSelectedFile3(fileName) {
        const index = this.selectedFiles3.indexOf(fileName);
        if (index !== -1) {
          this.selectedFiles3.splice(index, 1);
        }
      },
      removeSelectedFile4(fileName) {
        const index = this.selectedFiles4.indexOf(fileName);
        if (index !== -1) {
          this.selectedFiles4.splice(index, 1);
        }
      },
      addSelectedFile(fileName) {
        this.selectedFiles.push(fileName);
      },

      addSelectedFile3(fileName) {
        this.selectedFiles3.push(fileName);
      },

      addSelectedFile4(fileName) {
        this.selectedFiles4.push(fileName);
      },



      fileAdded(file, files) {
        console.log("Se cargó un archivo");
        console.log("estos son los files",this.files);
        let filesCharged = this.files;

        filesCharged = filesCharged.map((i)=> i.split('_',3)[2]);
        console.log("lo del if",filesCharged.includes(file.name))
        if(filesCharged.includes(file.name.toLowerCase())){
          Swal.fire({
            icon: "warning",
            title: "Archivo duplicado.",
            text: "Este archivo ya ha sido cargado. Por favor, seleccione otro.",
          });
          this.$refs.myVueDropzone.removeFile(file);
          return;
        }

        // Verificar si el archivo ya ha sido seleccionado
        if (this.isFileSelected(file.name)) {
          Swal.fire({
            icon: "warning",
            title: "Archivo duplicado.",
            text: "Este archivo ya ha sido seleccionado. Por favor, seleccione otro.",
          });
      
          // Cancelar la carga del archivo duplicado
          this.$refs.myVueDropzone.removeFile(file);
          return;
        }
      
        let totalSizeMB = (this.fileTotalMax + file.size) / (1024 * 1024);
      
        if (totalSizeMB > 10) {
          Swal.fire({
            icon: "warning",
            title: "Peso máximo alcanzado.",
            text: 'El peso máximo permitido para la carga de archivos es de 10MB.',
          });
      
          // Cancelar la carga del archivo que excede el límite
          this.$refs.myVueDropzone.removeFile(file);
          return;
        }
      
        this.fileTotalMax += file.size;
      
        let attachment = {
          _id: file.upload.uuid,
          title: file.name,
          type: "file",
          extension: "." + file.type.split("/")[1],
          user: JSON.parse(localStorage.getItem("user")),
          content: "File Upload by Select or Drop",
          thumb: file.dataURL,
          thumb_list: file.dataURL,
          isLoading: true,
          progress: null,
          size: file.size,
        };
      
        this.tempAttachments = [...this.tempAttachments, attachment];
      
        if (this.$refs.myVueDropzone.id === "dropzone") {
          console.log("Enviando desde dropzone 1 ems ");
          this.vueDropzoneFile.push(file);
          console.log("vuedropzonefile",this.vueDropzoneFile);
          this.setVueDropzoneFile(this.vueDropzoneFile);
        }
      
        // Agregar el nombre del archivo a la lista de seleccionados
        this.addSelectedFile(file.name);
      },
      
      isFileSelected(fileName) {
        // Verificar si el archivo ya está en la lista de archivos seleccionados
        return this.selectedFiles.includes(fileName);
      },
      isFileSelected3(fileName) {
        // Verificar si el archivo ya está en la lista de archivos seleccionados
        return this.selectedFiles3.includes(fileName);
      },
      isFileSelected4(fileName) {
        // Verificar si el archivo ya está en la lista de archivos seleccionados
        return this.selectedFiles4.includes(fileName);
      },
  
    /* mounted() {
      const dropzoneInstance = this.$refs.myVueDropzone.dropzone;
      dropzoneInstance.on("removedfile", (file) => {
        this.fileTotalMax -= file.size;
      });
    }, */

      // function called for every file dropped or selected
      fileAdded2(file) {

        if (this.isFileSelected(file.name)) {
          Swal.fire({
            icon: "warning",
            title: "Archivo duplicado.",
            text: "Este archivo ya ha sido seleccionado. Por favor, seleccione otro.",
          });
      
          // Cancelar la carga del archivo duplicado
          this.$refs.myVueDropzone2.removeFile(file);
          return;
        }

        let totalSizeMB = (this.fileTotalMax2 + file.size) / (1024 * 1024);
        console.log("File Dropped => ", file);
        console.log(file.type);

        if (totalSizeMB > 10) {
          Swal.fire({
            icon: "warning",
            title: "Peso máximo alcanzado.",
            text: 'El peso máximo permitido para la carga de archivos es de 10MB.',
          });
  
          // Cancel the upload of the file that exceeds the limit
          this.$refs.myVueDropzone2.removeFile(file);
          return;
        }

        this.fileTotalMax2 += file.size;

          let attachment = {};
          attachment._id = file.upload.uuid;
          attachment.title = file.name;
          attachment.type = "file";
          attachment.extension = "." + file.type.split("/")[1];
          attachment.user = JSON.parse(localStorage.getItem("user"));
          attachment.content = "File Upload by Select or Drop";
          attachment.thumb = file.dataURL;
          attachment.thumb_list = file.dataURL;
          attachment.isLoading = true;
          attachment.progress = null;
          attachment.size = file.size;
          this.tempAttachments = [...this.tempAttachments, attachment];
        /*} else {
          this.msg = "Formato de archivo incorrecto.";
          console.log(this.msg);
          alert("Formato de archivo incorrecto");
          if (file.size > 10) {
            alert("Subir archivos con un máximo de 10 MB. Intente de nuevo.");
          }
        }*/
        if (this.$refs.myVueDropzone2.id == "dropzone2") {
          console.log("Enviando desde dropzone 2 ems");
          this.vueDropzoneFileTwo.push(file);
          console.log(this.vueDropzoneFileTwo);
          this.setVueDropzoneFileTwo(this.vueDropzoneFileTwo);
        }
          this.addSelectedFile(file.name);
      },

      // function called for every file dropped or selected
      fileAdded3(file) {

        if (this.isFileSelected3(file.name)) {
          Swal.fire({
            icon: "warning",
            title: "Archivo duplicado.",
            text: "Este archivo ya ha sido seleccionado. Por favor, seleccione otro.",
          });
      
          // Cancelar la carga del archivo duplicado
          this.$refs.myVueDropzone3.removeFile(file);
          return;
        }

        let totalSizeMB = (this.fileTotalMax3 + file.size) / (1024 * 1024);
        console.log("File Dropped => ", file);
        console.log(file.type);

        if (totalSizeMB > 10) {
          Swal.fire({
            icon: "warning",
            title: "Peso máximo alcanzado.",
            text: 'El peso máximo permitido para la carga de archivos es de 10MB.',
          });
  
          // Cancel the upload of the file that exceeds the limit
          this.$refs.myVueDropzone3.removeFile(file);
          return;
        }

        this.fileTotalMax3 += file.size;

          let attachment = {};
          attachment._id = file.upload.uuid;
          attachment.title = file.name;
          attachment.type = "file";
          attachment.extension = "." + file.type.split("/")[1];
          attachment.user = JSON.parse(localStorage.getItem("user"));
          attachment.content = "File Upload by Select or Drop";
          attachment.thumb = file.dataURL;
          attachment.thumb_list = file.dataURL;
          attachment.isLoading = true;
          attachment.progress = null;
          attachment.size = file.size;
          this.tempAttachments = [...this.tempAttachments, attachment];

          if (this.$refs.myVueDropzone3.id == "dropzone3") {
            console.log("Enviando desde dropzone 3");
            this.vueDropzoneFileThree.push(file);
            console.log(this.vueDropzoneFileThree);
            this.setVueDropzoneFileThree(this.vueDropzoneFileThree);
          }
          this.addSelectedFile3(file.name);
      },

      // function called for every file dropped or selected
      fileAdded4(file) {
        console.log("thisfileselected4", this.isFileSelected4(file.name));
        if (this.isFileSelected4(file.name)) {
          Swal.fire({
            icon: "warning",
            title: "Archivo duplicado.",
            text: "Este archivo ya ha sido seleccionado. Por favor, seleccione otro.",
          });
      
          // Cancelar la carga del archivo duplicado
          this.$refs.myVueDropzone4.removeFile(file);
          return;
        }

        let totalSizeMB = (this.fileTotalMax4 + file.size) / (1024 * 1024);
        console.log("File Dropped => ", file);
        console.log(file.type);
        
        if (totalSizeMB > 10) {
          Swal.fire({
            icon: "warning",
            title: "Peso máximo alcanzado.",
            text: 'El peso máximo permitido para la carga de archivos es de 10MB.',
          });
  
          // Cancel the upload of the file that exceeds the limit
          this.$refs.myVueDropzone4.removeFile(file);
          return;
        }

        this.fileTotalMax4 += file.size;


          let attachment = {};
          attachment._id = file.upload.uuid;
          attachment.title = file.name;
          attachment.type = "file";
          attachment.extension = "." + file.type.split("/")[1];
          attachment.user = JSON.parse(localStorage.getItem("user"));
          attachment.content = "File Upload by Select or Drop";
          attachment.thumb = file.dataURL;
          attachment.thumb_list = file.dataURL;
          attachment.isLoading = true;
          attachment.progress = null;
          attachment.size = file.size;
          this.tempAttachments = [...this.tempAttachments, attachment];
        /*} else {
          this.msg = "Formato de archivo incorrecto.";
          console.log(this.msg);
          alert("Formato de archivo incorrecto");
          if (file.size > 10) {
            alert("Subir archivos con un máximo de 10 MB. Intente de nuevo.");
          }
        }*/

        if (this.$refs.myVueDropzone4.id == "dropzone4") {
          console.log("Enviando desde dropzone 4");
          this.vueDropzoneFileFour.push(file);
          console.log(this.vueDropzoneFileFour);
          this.setVueDropzoneFileFour(this.vueDropzoneFileFour);
        }
        this.addSelectedFile4(file.name);
      },

      // function called for every file dropped or selected
      fileAddedPN(file) {

        if (this.isFileSelected(file.name)) {
          Swal.fire({
            icon: "warning",
            title: "Archivo duplicado.",
            text: "Este archivo ya ha sido seleccionado. Por favor, seleccione otro.",
          });
      
          // Cancelar la carga del archivo duplicado
          this.$refs.vueDropzonePN.removeFile(file);
          return;
        }

        let totalSizeMB = (this.fileTotalMaxPN + file.size) / (1024 * 1024);
        console.log("File Dropped => ", file);
        console.log(file.type);
        
        if (totalSizeMB > 10) {
          Swal.fire({
            icon: "warning",
            title: "Peso máximo alcanzado.",
            text: 'El peso máximo permitido para la carga de archivos es de 10MB.',
          });
  
          // Cancel the upload of the file that exceeds the limit
          this.$refs.vueDropzonePN.removeFile(file);
          return;
        }

        this.fileTotalMaxPN += file.size;

          let attachment = {};
          attachment._id = file.upload.uuid;
          attachment.title = file.name;
          attachment.type = "file";
          attachment.extension = "." + file.type.split("/")[1];
          attachment.user = JSON.parse(localStorage.getItem("user"));
          attachment.content = "File Upload by Select or Drop";
          attachment.thumb = file.dataURL;
          attachment.thumb_list = file.dataURL;
          attachment.isLoading = true;
          attachment.progress = null;
          attachment.size = file.size;
          this.tempAttachments = [...this.tempAttachments, attachment];
        /*} else {
          this.msg = "Formato de archivo incorrecto.";
          console.log(this.msg);
          alert("Formato de archivo incorrecto");
          if (file.size > 10) {
            alert("Subir archivos con un máximo de 10 MB. Intente de nuevo.");
          }
        }*/
        if (this.$refs.vueDropzonePN.id == "dropzonePN") {
          this.vueDropzoneFilePN.push(file);
          console.log(this.vueDropzoneFilePN);
          this.setVueDropzoneFilePN(this.vueDropzoneFilePN);
        }
        this.addSelectedFile(file.name);
      },

      // a middle layer function where you can change the XHR request properties
      sendingFiles(files, xhr, formData) {
        if (files.type == "application/pdf" || 
          files.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
          || files.type == "image/jpeg" || files.type == "image/png" || 
          files.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
          || files.type == "application/vnd.ms-excel" && files.size <= 10000000) {
          console.log(
            "if you want to change the upload time or add data to the formData you can do it here."
          );
          console.log("Files sending", files);
        }
        
      },
      // function where we get the upload progress
      uploadProgress(file, progress, bytesSent) {
        if (file.type == "application/pdf" || 
          file.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
          || file.type == "image/jpeg" || file.type == "image/png" || 
          file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
          || file.type == "application/vnd.ms-excel" && file.size <= 10000000) {
          console.log("File Upload Progress", progress);
          this.tempAttachments.map(attachment => {
            if (attachment.title === file.name) {
              attachment.progress = `${Math.floor(progress)}`;
            }
          });
        }
      },
      // called on successful upload of a file
      success(file, response) {
        for (var i=0; i<file.length; i++) {
          /*if (file[i].type == "application/pdf" || 
            file[i].type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
            || file[i].type == "image/jpeg" || file[i].type == "image/png" || 
            file[i].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
            || file[i].type == "application/vnd.ms-excel" && file[i].size <= 10000000) {*/
            console.log("File uploaded successfully");
            console.log("Response is ->", response);
            console.log("file is ->", file[i]);
            console.log("file sin i ->", file);
            console.log("ref ->", this.$refs.myVueDropzone); //IMPORTANT, check vuedropzone properties
            if (this.$refs.myVueDropzone.id == "dropzone") {
              //this.setVueDropzoneFile(file);
              //this.companyBackgroundUpload();
              for(var i = 0; i<file.length; i++) {

                console.log("Enviando desde dropzone 1");
                this.vueDropzoneFile.push(file[i]);
              }
              console.log(this.vueDropzoneFile);
              this.setVueDropzoneFile(this.vueDropzoneFile);
            }
            
            //this.test(response);
          /*}else {
            file[i] = ''
          }*/
        }
      },

      success2(file, response) {
        for (var i=0; i<file.length; i++) {
          /*if (file[i].type == "application/pdf" || 
            file[i].type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
            || file[i].type == "image/jpeg" || file[i].type == "image/png" || 
            file[i].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
            || file[i].type == "application/vnd.ms-excel" && file[i].size <= 10000000) {*/
            console.log("File uploaded successfully");
            console.log("Response is ->", response);
            console.log("file is ->", file[i]);
            console.log("file sin i ->", file);
            console.log("ref ->", this.$refs.myVueDropzone2);

            if (this.$refs.myVueDropzone2.id == "dropzone2") {
              //this.setVueDropzoneFile(file);
              //this.companyBackgroundUpload();
              for(var i = 0; i<file.length; i++) {

                console.log("Enviando desde dropzone 2");
                this.vueDropzoneFileTwo.push(file[i]);
              }
              console.log(this.vueDropzoneFileTwo);
              this.setVueDropzoneFileTwo(this.vueDropzoneFileTwo);
            }
            
            //this.test(response);
          /*}else {
            file[i] = ''
          }*/
        }
      },

      success3(file, response) {
        for (var i=0; i<file.length; i++) {
            console.log("File uploaded successfully");
            console.log("Response is ->", response);
            console.log("file is ->", file[i]);
            console.log("file sin i ->", file);
            console.log("ref ->", this.$refs.myVueDropzone3);
            if (this.$refs.myVueDropzone3.id == "dropzone3") {
              for(var i = 0; i<file.length; i++) {
                console.log("Enviando desde dropzone 3");
                this.vueDropzoneFileThree.push(file[i]);
              }
              console.log(this.vueDropzoneFileThree);
              this.setVueDropzoneFileThree(this.vueDropzoneFileThree);
            }
        }
      },

      success4(file, response) {
        for (var i=0; i<file.length; i++) {
            console.log("File uploaded successfully");
            console.log("Response is ->", response);
            console.log("file is ->", file[i]);
            console.log("file sin i ->", file);
            console.log("ref ->", this.$refs.myVueDropzone4);
            if (this.$refs.myVueDropzone4.id == "dropzone4") {
              for(var i = 0; i<file.length; i++) {
                console.log("Enviando desde dropzone 4");
                this.vueDropzoneFileFour.push(file[i]);
              }
              console.log(this.vueDropzoneFileFour);
              this.setVueDropzoneFileFour(this.vueDropzoneFileFour);
            }

        }
      },

      successPN(file, response) {
        for (var i=0; i<file.length; i++) {
          /*if (file[i].type == "application/pdf" || 
            file[i].type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
            || file[i].type == "image/jpeg" || file[i].type == "image/png" || 
            file[i].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
            || file[i].type == "application/vnd.ms-excel" && file[i].size <= 10000000) {*/
            console.log("File uploaded successfully");
            console.log("Response is ->", response);
            console.log("file is ->", file[i]);
            console.log("file sin i ->", file);
            console.log("ref ->", this.$refs.vueDropzonePN);

            if (this.$refs.vueDropzonePN.id == "dropzonePN") {
              //this.setVueDropzoneFile(file);
              //this.companyBackgroundUpload();
              for(var i = 0; i<file.length; i++) {

                console.log("Enviando desde dropzone 4");
                this.vueDropzoneFilePN.push(file[i]);
              }
              console.log(this.vueDropzoneFilePN);
              this.setVueDropzoneFilePN(this.vueDropzoneFilePN);
            }
            
            //this.test(response);
          /*}else {
            file[i] = ''
          }*/
        }
      },

      removeFile(file, error, xhr) {
        console.log(file);
        console.log("Id del archivo que eliminé: " + file.upload.uuid);
      
        if (this.vueDropzoneFile.length > 0) {
          for (let i = 0; i < this.vueDropzoneFile.length; i++) {
            if (file.upload.uuid === this.vueDropzoneFile[i].upload.uuid) {
              // Reducir el tamaño total
              this.fileTotalMax -= this.vueDropzoneFile[i].size;
      
              // Eliminar el archivo del arreglo
              this.vueDropzoneFile.splice(i, 1);
              console.log("Borrando desde dropzone 1");
      
              // Eliminar el nombre del archivo de la lista de seleccionados
              this.removeSelectedFile(file.name);
              break; // Encontramos el archivo, no es necesario continuar recorriendo
            }
          }
        }
      
        console.log(this.vueDropzoneFile);
      },

      removeFile2(file, error, xhr) {
        console.log(file)
        console.log("Id del archivo que eliminé: " + file.upload.uuid)
        console.log("Array dropzone 2 before deleting: " + this.vueDropzoneFileTwo);
       if (this.vueDropzoneFileTwo.length > 0) {
          for(var i=0; i<this.vueDropzoneFileTwo.length; i++) {
            if (file.upload.uuid == this.vueDropzoneFileTwo[i].upload.uuid) {
              this.fileTotalMax2 -= this.vueDropzoneFileTwo[i].size;
              this.vueDropzoneFileTwo.splice(i, 1);
              console.log("Borrando desde dropzone 2");
              this.removeSelectedFile(file.name);
              break;
            }
          }
        }
        
        console.log(this.vueDropzoneFileTwo);
      },

      removeFile3(file, error, xhr) {
        console.log(file)
        console.log("Id del archivo que eliminé: " + file.upload.uuid)
       if (this.vueDropzoneFileThree.length > 0) {
          for(var i=0; i<this.vueDropzoneFileThree.length; i++) {
            if (file.upload.uuid == this.vueDropzoneFileThree[i].upload.uuid) {
              this.fileTotalMax3 -= this.vueDropzoneFileThree[i].size;
              this.vueDropzoneFileThree.splice(i, 1);
              console.log("Borrando desde dropzone 3");
              this.removeSelectedFile3(file.name);
              break;
            }
              console.log(this.vueDropzoneFileThree[i]);
          }
        }
        console.log(this.vueDropzoneFileThree);
      },

      removeFile4(file, error, xhr) {
        console.log(file)
        console.log("Id del archivo que eliminé: " + file.upload.uuid)
      if (this.vueDropzoneFileFour.length > 0) {
        for(var i=0; i<this.vueDropzoneFileFour.length; i++) {
          if (file.upload.uuid == this.vueDropzoneFileFour[i].upload.uuid) {
            this.fileTotalMax4 -= this.vueDropzoneFileFour[i].size;
            this.vueDropzoneFileFour.splice(i, 1);
            console.log("Borrando desde dropzone 4");
            this.removeSelectedFile4(file.name);
              break;
          }
            console.log(this.vueDropzoneFileFour[i]);
        }
      }
        
        console.log(this.vueDropzoneFileFour);
      },

      removeFilePN(file, error, xhr) {
        console.log(file)
        console.log("Id del archivo que eliminé: " + file.upload.uuid)
      if (this.vueDropzoneFilePN.length > 0) {
        for(var i=0; i<this.vueDropzoneFilePN.length; i++) {
          if (file.upload.uuid == this.vueDropzoneFilePN[i].upload.uuid) {
            this.fileTotalMaxPN -= this.vueDropzoneFilePN[i].size;
            this.vueDropzoneFilePN.splice(i, 1);
            console.log("Borrando desde dropzone Persona Natural");
            this.removeSelectedFile(file.name);
              break;
          }
            console.log(this.vueDropzoneFilePN[i]);
        }
      }
        
        console.log(this.vueDropzoneFilePN);
      }
   },

   computed: {
     getTempAttachments() {
        return this.tempAttachments;
      },
      getAttachments() {
        return this.attachments;
      },
   }
}